module.exports = __webpack_public_path__ + "./assets/img_ntu_grey__537782bf23f77af31b985e93be3baed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ntu_grey.jpg
// module id = 605
// module chunks = 12